var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 10.0001C1.75 9.8343 1.81585 9.67533 1.93306 9.55812C2.05027 9.44091 2.20924 9.37506 2.375 9.37506H17.1163L13.1825 5.44256C13.0651 5.3252 12.9992 5.16603 12.9992 5.00006C12.9992 4.83409 13.0651 4.67492 13.1825 4.55756C13.2999 4.4402 13.459 4.37427 13.625 4.37427C13.791 4.37427 13.9501 4.4402 14.0675 4.55756L19.0675 9.55756C19.1257 9.61561 19.1719 9.68458 19.2034 9.76052C19.2349 9.83645 19.2511 9.91785 19.2511 10.0001C19.2511 10.0823 19.2349 10.1637 19.2034 10.2396C19.1719 10.3155 19.1257 10.3845 19.0675 10.4426L14.0675 15.4426C13.9501 15.5599 13.791 15.6258 13.625 15.6258C13.459 15.6258 13.2999 15.5599 13.1825 15.4426C13.0651 15.3252 12.9992 15.166 12.9992 15.0001C12.9992 14.8341 13.0651 14.6749 13.1825 14.5576L17.1163 10.6251H2.375C2.20924 10.6251 2.05027 10.5592 1.93306 10.442C1.81585 10.3248 1.75 10.1658 1.75 10.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsArrowRight);
export default __webpack_public_path__ + "static/media/BsArrowRight.619bf1486bce46c166cf1056105647ff.svg";
export { ForwardRef as ReactComponent };